import React, { useRef, useState } from "react";
import ReactSignatureCanvas from "react-signature-canvas";

export default function SignaturePad({ onSave, onCancel }) {
  const [mode, setMode] = useState("draw");
  const [typedSig, setTypedSig] = useState("");
  const sigRef = useRef(null);

  function handleSave() {
    if (mode === "draw") {
      if (!sigRef.current || sigRef.current.isEmpty()) {
        alert("Please draw your signature.");
        return;
      }
      onSave({ signatureType: "drawn", signatureData: sigRef.current.toDataURL("image/png") });
    } else {
      if (!typedSig.trim()) {
        alert("Please type your name.");
        return;
      }
      onSave({ signatureType: "typed", signatureData: typedSig.trim() });
    }
  }

  return (
    <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm">
      <div className="flex gap-2 mb-4">
        <button
          onClick={() => setMode("draw")}
          className={`px-4 py-2 rounded-lg text-sm font-medium transition ${mode === "draw" ? "bg-blue-600 text-white" : "bg-gray-100 text-gray-700 hover:bg-gray-200"}`}
        >
          Draw Signature
        </button>
        <button
          onClick={() => setMode("type")}
          className={`px-4 py-2 rounded-lg text-sm font-medium transition ${mode === "type" ? "bg-blue-600 text-white" : "bg-gray-100 text-gray-700 hover:bg-gray-200"}`}
        >
          Type Signature
        </button>
      </div>

      {mode === "draw" ? (
        <div>
          <div className="border-2 border-dashed border-gray-300 rounded-lg bg-gray-50 mb-3">
            <ReactSignatureCanvas
              ref={sigRef}
              penColor="#1e3a8a"
              canvasProps={{ width: 500, height: 160, className: "w-full rounded-lg" }}
            />
          </div>
          <button
            onClick={() => sigRef.current?.clear()}
            className="text-sm text-gray-500 hover:text-red-500 underline"
          >
            Clear
          </button>
        </div>
      ) : (
        <div>
          <input
            type="text"
            placeholder="Type your full legal name"
            value={typedSig}
            onChange={(e) => setTypedSig(e.target.value)}
            className="w-full border border-gray-300 rounded-lg px-4 py-3 text-2xl font-serif italic focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <p className="text-xs text-gray-400 mt-1">This typed name will serve as your electronic signature.</p>
        </div>
      )}

      <div className="flex gap-3 mt-5">
        <button
          onClick={handleSave}
          className="flex-1 bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 rounded-lg transition"
        >
          Apply Signature
        </button>
        {onCancel && (
          <button
            onClick={onCancel}
            className="px-6 py-3 border border-gray-300 rounded-lg text-gray-600 hover:bg-gray-50 transition"
          >
            Cancel
          </button>
        )}
      </div>
    </div>
  );
}
